import styled from 'styled-components';

export const ModCatTable = styled.div`
  .export-xls {
    background: #002f6c !important;
  }
  .see-all {
    color: #949494;
  }

  .bg-title {
    background-color: #002f6c;
    border-radius: 8px 8px 0px 0px;
  }

  .bg-title,
  .table-rows {
    span:nth-child(1) {
      width: 9%;
    }
    span:nth-child(2) {
      width: 20%;
    }
    span:nth-child(3) {
      width: 17%;
    }
    span:nth-child(4) {
      width: 17%;
    }
    span:nth-child(5) {
      width: 37%;
    }
  }

  .table-rows span {
    color: #7e7e7e;
  }

  .btn-arrow {
    background-color: #ff842f;
  }

  .table {
    > div:first-child {
      padding: 0px !important;
    }
    div {
      border: none;
    }
  }

  .content {
    border-radius: 8px 8px 0px 0px;
    ::-webkit-scrollbar {
      background: transparent;
      width: 5px;
      height: 8px;
      border: none;
    }
    ::-webkit-scrollbar-thumb {
      background-color: #002f6c;
      border-radius: 4px;
    }
  }

  .tb-header {
    background-color: #002f6c;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    padding: 9px 16px;
    width: 100%;
  }

  .tb-header .tb-row button {
    color: #fff;
    font-family: 'Roboto';
    font-size: 18px;
    font-weight: 400;
    justify-content: center;

    svg {
      color: #fff !important;
    }
  }

  .tb-header .tb-row button {
    svg {
      display: none;
    }
  }

  .tb-body {
    width: 100%;
  }

  .tb-body .tb-row {
    padding: 1rem 0.5rem;
    text-align: center;

    :not(:last-child) {
      border-bottom: 0.5px solid #e1e1e1;
    }
    div {
      color: #7e7e7e;

      font-size: 16px;
      font-weight: 400;

      text-wrap: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      padding: 0px 15px;
    }
  }

  @media screen and (min-width: 992px) {
    .tb-header .tb-row {
      width: 100%;

      button:nth-child(1) {
        width: 30%;
      }
      button:nth-child(2) {
        width: 20%;
      }
      button:nth-child(3) {
        width: 20%;
      }
      button:nth-child(4) {
        width: 15%;
      }
      button:nth-child(5) {
        width: 15%;
      }
      button:nth-child(6) {
        width: 12%;
      }
    }

    .tb-body .tb-row {
      padding: 0.5rem;
      div:nth-child(1) {
        width: 30%;
      }
      div:nth-child(2) {
        width: 20%;
      }
      div:nth-child(3) {
        width: 20%;
      }
      div:nth-child(4) {
        width: 15%;
      }
      div:nth-child(5) {
        width: 15%;
      }
      div:nth-child(6) {
        width: 12%;
      }
    }
  }
`;
